import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark, ArrowRight } from "lucide-react";
import api from "../lib/api";
import ArticleCard from "../components/ArticleCard";
import Reveal from "../components/Reveal";

export default function ReadingListPage() {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("mm-bookmarks") || "[]");
    if (saved.length === 0) {
      setArticles([]);
      return;
    }
    api.get("/articles")
      .then((r) => setArticles(r.data.filter((a) => saved.includes(a.slug))))
      .catch(() => setArticles([]));
  }, []);

  return (
    <div data-testid="reading-list-page" className="max-w-[1440px] mx-auto px-5 lg:px-10 py-16 lg:py-24">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-kinetic mb-4">Your shelf</p>
        <h1 className="font-display font-black uppercase text-4xl sm:text-6xl lg:text-7xl tracking-tight">Reading List</h1>
        <p className="text-ash mt-5 max-w-lg leading-relaxed">
          Every story you bookmarked, kept in one place. Tap the bookmark on any story card to add or remove it.
        </p>
      </Reveal>

      {!articles ? (
        <p className="font-mono text-ash text-xs uppercase tracking-[0.3em] py-24 text-center animate-pulse">Loading your shelf…</p>
      ) : articles.length === 0 ? (
        <div data-testid="reading-list-empty" className="border border-dashed border-white/15 py-24 text-center mt-14">
          <Bookmark size={28} className="text-ash mx-auto mb-5" />
          <p className="font-mono text-ash text-xs uppercase tracking-[0.3em] mb-8">Your shelf is empty.</p>
          <Link to="/" data-testid="reading-list-browse-cta"
            className="group inline-flex items-center gap-2 bg-kinetic text-obsidian font-mono text-xs uppercase tracking-[0.18em] font-medium px-7 py-4 rounded-full hover:bg-porcelain transition-colors duration-300">
            Browse the latest <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform duration-300" />
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {articles.map((a, i) => (
            <ArticleCard key={a.id} article={a} index={i} large={i % 7 === 0} />
          ))}
        </div>
      )}
    </div>
  );
}
